const enterprise = [
  {
    path: '/sz-metro/report',
    name: 'sz-metro-eport',
    component: () => import(/* webpackChunkName: "footmark" */ '@/pages/sz-metro/report-comtrast.vue')
  },
  {
    path: '/sz-metro/history',
    name: 'sz-metro-history',
    component: () => import(/* webpackChunkName: "footmark" */ '@/pages/sz-metro/health-history.vue')
  },
  {
    path: '/cmb-home',
    name: 'cmb-home',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/third-party/cmb-home.vue')
  }
]

export default enterprise
